/*
 *
 * GroupedRadioSelector
 *
 * @version 1.0.0
 * @author Patrizia Petrera
 * @since 04-Jul-2025
*/

import { connect } from 'react-redux'
// import { bindActionCreators } from 'redux'
import GroupedRadioSelector from './GroupedRadioSelector'

const mapDispatchToProps = dispatch => ({

})

const mapStateToProps = () => ({

})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(GroupedRadioSelector)
